// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/less.less'
// import {List, Uploader, Toast, Popup, DatetimePicker, Circle,Picker, Tabbar, TabbarItem, Calendar, Empty, PullRefresh,Step } from 'vant'
import Vant from 'vant'
import  {Avatar}  from 'vant-green';
import 'vant/lib/index.css'
import VueLuckyCanvas from '@lucky-canvas/vue'
import './utils/flexible'

// 获取当前环境
import env from './assets/js/env';
Vue.prototype.$env = env;

// const uses = [List, Uploader, Toast, Popup, DatetimePicker, Circle,Picker, Tabbar, TabbarItem, Calendar, Empty, PullRefresh,Step]
// uses.forEach(use => {
//   Vue.use(use)
// })
Vue.use(Vant);
Vue.use(Avatar);
// 引入vue2-touch-events
import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(Vue2TouchEvents);

// 引入px2jspx方法
import px2jspx from './assets/js/px2jspx'
Vue.prototype.$px2jspx = px2jspx;
// 引入px2rem方法
import px2rem from './assets/js/px2rem';
Vue.prototype.$px2rem = px2rem;

// 引入pinia
import { createPinia, PiniaVuePlugin } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
// Vue 2.7 已内置 Composition API，勿再 Vue.use(@vue/composition-api)，否则 setup 绑定会重复声明告警
Vue.use(PiniaVuePlugin)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// 引入全局过滤器
import * as filters from './filters/index'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false
//错误提示
import creatErrorJs from '@/unit/creatError.js'
Vue.prototype.$creatErrorJs = creatErrorJs;

// 按需加载ElementUI
import { Loading,Message,MessageBox,Button,Radio,Dialog,Input,Form,FormItem,TabPane,Tabs,tooltip,Checkbox,DatePicker,Select,Option,Cascader,Switch,Icon,Table,TableColumn, } from 'element-ui';
Vue.use(Loading);
Vue.use(Button);
Vue.use(Radio);
Vue.use(Dialog);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(TabPane);
Vue.use(Tabs);
Vue.use(tooltip);
Vue.use(Checkbox);
Vue.use(DatePicker);
Vue.use(Select);
Vue.use(Option);
Vue.use(Cascader);
Vue.use(Switch);
Vue.use(Icon);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(VueLuckyCanvas)

Vue.directive('numberOnly', {
  bind: function(el) {
    el.handler = function() {
      el.childNodes[1].value = el.childNodes[1].value.replace(/\D+/g, '');//因为是elementui组件里使用的el.value获取不到我们输入的内容。然后我发现他的第一个孩子才是我们输入的手机号码的内容。
    }
    el.addEventListener('keyup', el.handler); //这里使用keyup。我开始用的input发现第一次输入拼音字母竟然是可以输入的。改成keyup就都不能输入非数字了
  },
  unbind: function(el) {
    el.removeEventListener('keyup', el.handler);
  }
})
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
/* eslint-disable no-new */

// VConsole：仅白名单账号登录后显示（见 src/utils/vconsole.js）
import { syncVConsole } from '@/utils/vconsole';
// 尽早注册原生上传回调 stub，避免 iOS 相册返回整页刷新后回调丢失
import { ensureUploadImageResultStub, getUploadDebugLogs } from '@/views/mine/healthSurvey/healthSurveyUpload';
ensureUploadImageResultStub();
if (typeof window !== 'undefined') {
  window.getUploadDebugLogs = getUploadDebugLogs;
}
syncVConsole();

new Vue({
  el: '#app',
  router,
  pinia,
  components: { App },
  template: '<App/>',
  data:{
    bus: new Vue()
  }
})



// WEBPACK FOOTER //
// ./src/main.js